
export const titleKeyMap: Record<string, string> = {
  "首页": "Home",
  "仪表盘": "Dashboard",
  "数据看板": "DataBoard",
  "数据分析": "Data Analysis",
  "系统": "System",
  "项目管理": "Project Management",
  "调查列表": "Survey List",
  "调查记录": "Survey Record",
  "终止记录": "Termination Record",
  "会员管理": "Member Management",
  "会员列表": "Member List",
  "会员组": "Member Group",
  "会员等级": "Member Level",
  "财务管理": "Financial Management",
  "财务记录": "Financial Record",
  "我的账单": "My Bill",
  "员工财务管理": "Employee Financial",
  "员工账单": "Employee Bill",
  "会员财务日志": "Member Financial Log",
  "会员账单": "Member Bill",
  "组织": "Organization",
  "组织架构": "Organization Structure",
  "员工管理": "Employee Management",
  "角色管理": "Role Management",
  "部门管理": "Department Management",
  "设置": "Settings",
  "配置管理": "Configuration Management",
  "系统配置": "System Configuration",
  "开发者": "Developer",
  "项目调度": "Project Scheduling"
};

// 导出类型定义，方便其他地方使用
export type TitleKeyMapType = typeof titleKeyMap;


//英文映射中文
export const titleenKeyMap: Record<string, string> = {
  "Home": "首页",
  "Dashboard": "仪表盘",
  "DataBoard": "数据看板",
  "Data Analysis": "数据分析",
  "System": "系统",
  "Project Management": "项目管理",
  "Survey List": "调查列表",
  "Survey Record": "调查记录",
  "Termination Record": "终止记录",
  "Member Management": "会员管理",
  "Member List": "会员列表",
  "Member Group": "会员组",
  "Member Level": "会员等级",
  "Financial Management": "财务管理",
  "Financial Record": "财务记录",
  "My Bill": "我的账单",
  "Employee Financial": "员工财务管理",
  "Employee Bill": "员工账单",
  "Member Financial Log": "会员财务日志",
  "Member Bill": "会员账单",
  "Organization": "组织",
  "Organization Structure": "组织架构",
  "Employee Management": "员工管理",
  "Role Management": "角色管理",
  "Department Management": "部门管理",
  "Settings": "设置",
  "Configuration Management": "配置管理",
  "System Configuration": "系统配置",
  "Developer": "开发者",
  "Project Scheduling": "项目调度"
}





